// extracted by mini-css-extract-plugin
module.exports = {"wfzqr02":"wfzqr02"};